import apiClient from '@/api/base'

/**
 * User API module
 * Handles all API requests related to the /me endpoints
 */
const userApi = {
  /**
   * Get current user information
   * @returns {Promise} Promise that resolves to the user data
   */
  async getCurrentUser() {
    const response = await apiClient.get('/me')
    return response.data
  },
}

export default userApi
